<template>
  <!-- <section> -->
  <div class="login-box mx-auto">
    <div class="card">
      <div class="card-body login-card-body">
        <div class="login-logo">
          <img width="40%" height="auto" src="@/assets/login/Logo.png">
        </div>       
        <p class="login-box-msg text-bold"><span v-if="$route.name == 'resetPassword'">{{ $t('words.reset_password') }}</span><span v-else>Cadastrar</span></p>
        <div class="form-group" :class="{'is-invalid':errors.has('email')}">
          <label class="control-label">{{ $t('attributes.email')}}:</label>
          <input v-model="auth.email" v-validate="{required:true, email:true}" type="email"
            :placeholder="$t('words.type_email')" class="form-control" name="email" autofocus>
          <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
          <div class="invalid-feedback help-block error">{{errors.first('email')}}</div>
        </div>
        <div class="form-group" :class="{'is-invalid':errors.has('password')}">
          <label class="control-label">{{ $t('attributes.password')}}</label>
          <input v-model="auth.password" v-validate="{required:true, min:6}" ref="password" type="password"
            :placeholder="$t('attributes.password')" class="form-control" name="password">
          <span class="glyphicon glyphicon-lock form-control-feedback"></span>
          <div class="invalid-feedback help-block error">{{errors.first('password')}}</div>
        </div>
        <div class="form-group" :class="{'is-invalid':errors.has('password_confirmation')}">
          <label class="control-label">Confirmar Senha</label>
          <input v-model="auth.password_confirmation"
            v-validate="auth.password.length > 0 ? 'required|confirmed:password' : ''"
            :placeholder="'Confirmar Senha'" type="password" class="form-control"
            name="password_confirmation">
          <span class="glyphicon glyphicon-lock form-control-feedback"></span>
          <div class="invalid-feedback help-block error">{{errors.first('password_confirmation')}}</div>
        </div>
        <br>
        <div class="row justify-content-between m-0">
          <button @click="status.box='login'" class="btn btn-default">
            <i class="fa fa-times"></i> {{$t('words.back')}}
          </button>
          <button type="button" @click="submit" :disabled="loading" class="btn btn-primary">
            <i class="fa fa-check"></i> {{$t('words.save')}} <i v-show="loading"
              class="fa fa-circle-o-notch fa-spin"></i>
          </button>
        </div>
      </div>
    </div>
    <div id="ChoiceCompany" class="modal fade in" data-backdrop="static" data-keyboard="false" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- Modal content-->
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title"><i class="fa fa-building"></i> {{$t('message.choice_company')}}</h4>
          </div>
          <div class="modal-body">
            <h4>{{loginMsg}}</h4>
            <div class="form-group">
              <required /> <label>{{$t('words.company')}}</label>
              <select name="company" :class="{ 'is-invalid': errors.has('company') }" v-model="companyId"
                v-validate="{required:true}" class='form-control'>
                <option value=''>{{$t('words.select')}}</option>
                <option v-for="(item, i) in companies" :value="item.id" :key="i">{{item.nome}}</option>
              </select>
              <div class="invalid-feedback help-block error">{{errors.first('company')}}</div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" data-dismiss="modal" class="btn btn-default float-left">
              <i class="fa fa-times"></i> {{$t('words.cancel')}}
            </button>
            <button type="button" @click="logar" :disabled="loadingModal" class="btn btn-success"><i
                class="fa fa-check"></i>
              {{$t('words.access')}}
              <i v-show="loadingModal" class="fa fa-circle-o-notch fa-spin"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
  export default {
    props: ['status'],
    data() {
      return {
        auth: {
          email: '',
          password: '',
          password_confirmation: '',
          token: '',
          remember: false
        },
        loading: false,
        loginMsg: '',
        loadingModal: false,
        message: '',
        companies: [],
        companyId: ''
      };
    },
    beforeMounted() {
      this.$auth.check().then(response => {
        if (response) {
          this.$router.push({
            name: 'index'
          });
        }
      });
    },
    methods: {
      submit() {
        this.$validator
          .validateAll(['email', 'password', 'password_confirmation'])
          .then(valid => {
            if (valid) {
              this.loading = true;
              this.auth.token = this.$route.params.token;
              this.$auth
                .resetPassword(this.auth)
                .then(response => {
                  this.loading = false;
                  if (response.data.status !== undefined) {
                    toastr({
                      icon: 'success',
                      title: response.data.message
                    });
                    this.$auth
                      .login(this.auth)
                      .then(response => {
                        this.loading = false;
                        if (response.data.access_token) {
                           window.location.href="/dashboard";
                        } else {
                          this.showModal(response);
                        }
                      })
                      .catch(error => {
                        console.log(error);
                        this.loading = false;
                      });
                  }
                })
                .catch(error => {
                  this.loading = false;
                  if (error.response.data.status !== undefined) {
                    toastr({
                      icon: 'error',
                      title: error.response.data.message
                    });
                  }
                });
            }
          });
      },
      showModal(response) {
        this.loginMsg = response.data.message;
        this.companies = response.data.empresas;
        $('#ChoiceCompany').modal('toggle');
      },
      logar() {
        this.$validator.validateAll(['company']).then(valid => {
          if (valid) {
            this.loadingModal = true;
            this.$auth
              .logar(this.auth, this.companyId)
              .then(response => {
                this.loadingModal = false;
                if (response.status !== 'warning') {
                  $('#ChoiceCompany').modal('toggle');
                   window.location.href="/dashboard";
                } else {
                  toastr({
                    icon: response.status,
                    title: response.message
                  });
                }
                // window.location = "/";
              })
              .catch(error => {
                this.loadingModal = false;
                this.loading = false;
                console.log(error);
                this.signin_error = this.$t('auth.failed');
              });
          }
        });
      }
    }
  };
</script>

<style scoped>
  /* body {
    background-image: url("../../assets/body.jpg");
    background-size: 100vw 100vh;
    background-attachment: fixed;
  } */

  .login-box {
    /* width: 100%; */
    margin: 0;
  }

  .login-box-body {
    /* margin-top: -15%; */
    /* background-color: rgba(255, 255, 255, .15); */
    background: #ffffffdd !important;
  }

  .login-box-body .form-control {
    background-color: transparent;
    border: 0;
    border-bottom: 1px solid dimgray;
  }

  .login-box-body input.form-control::placeholder {
    color: dimgray;
  }

  .login-box-body input.form-control:focus {
    outline-width: 0;
  }

  .login-box-body .form-control-feedback {
    left: 0;
  }

  .login-box-body .has-feedback .form-control {
    padding-right: 12px;
    padding-left: 30px;
  }

  /*
.login-img {
margin-top: 5%;
width: 40vw;
right: -20%;
position: relative;
overflow: hidden;
} */

  @keyframes pulse {
    from {
      transform: translateX(-50%) skewX(-15deg);
    }

    to {
      transform: translateX(900%) skewX(-15deg);
    }
  }

  @-webkit-keyframes pulse {
    from {
      -webkit-transform: translateX(-100%) skewX(-15deg);
    }

    to {
      -webkit-transform: translateX(400%) skewX(-15deg);
    }
  }

  @-moz-keyframes pulse {
    from {
      -moz-transform: translateX(-100%) skewX(-15deg);
    }

    to {
      -wemozbkit-transform: translateX(400%) skewX(-15deg);
    }
  }

  @-ms-keyframes pulse {
    from {
      -ms-transform: translateX(-100%) skewX(-15deg);
    }

    to {
      -ms-transform: translateX(400%) skewX(-15deg);
    }
  }

  @-o-keyframes pulse {
    from {
      -o-transform: translateX(-100%) skewX(-15deg);
    }

    to {
      -o-transform: translateX(400%) skewX(-15deg);
    }
  }
</style>